import { AltaModeloDispositivoComponent } from './components/modelo-dispositivo/alta-modelo-dispositivo/alta-modelo-dispositivo.component';
import { AltaMarcaDispositivoComponent } from './components/marca-dispositivo/alta-marca-dispositivo/alta-marca-dispositivo.component';
import { AltaDispositivoComponent } from './components/dispositivo/alta-dispositivo/alta-dispositivo.component';
import { DispositivoComponent } from './components/dispositivo/dispositivo.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DispositivosComponent } from './dispositivos.component';
import { MarcaDispositivoComponent } from './components/marca-dispositivo/marca-dispositivo.component';
import { ModeloDispositivoComponent } from './components/modelo-dispositivo/modelo-dispositivo.component';

const routes: Routes = [
  {
	path: '',
    children: [
      {
        path: 'dispositivo',
        component: DispositivoComponent,
      },
      {
        path: 'dispositivo/alta',
        component: AltaDispositivoComponent
      },
      {
        path: 'dispositivo/editar/:imei',
        component: AltaDispositivoComponent
      },
      {
        path: 'marca',
        component: MarcaDispositivoComponent
      },
      {
        path: 'marca/alta',
        component: AltaMarcaDispositivoComponent
      },
      {
        path: 'marca/editar/:idMarca',
        component: AltaMarcaDispositivoComponent
      },
      {
        path: 'modelo',
        component: ModeloDispositivoComponent
      },
      {
        path: 'modelo/alta',
        component: AltaModeloDispositivoComponent
      },
      {
        path: 'modelo/editar/:idModelo',
        component: AltaModeloDispositivoComponent
      }
    ]
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DispositivosRoutingModule { }
